/**
 * Ensures document URLs open as absolute links, not relative to the current route.
 */
export function normalizeDocumentUrl(url: string): string {
  const trimmed = url.trim().split("#")[0];
  if (!trimmed) {
    return trimmed;
  }

  if (/^https?:\/\//i.test(trimmed)) {
    return trimmed;
  }

  if (trimmed.startsWith("//")) {
    return `https:${trimmed}`;
  }

  return `https://${trimmed}`;
}

export function isAzureBlobUrl(url: string): boolean {
  return url.includes("blob.core.windows.net");
}
